/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promos_Record_CtaInputs */



/**
* | output |
* | --- |
* | "Record promo cards distributed" |
*
* @param {Promos_Record_CtaInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promos_record_cta = /** @type {((inputs?: Promos_Record_CtaInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promos_Record_CtaInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Enregistrer les cartes promo distribuées")
	if (locale === "es") return /** @type {LocalizedString} */ ("Registrar las cartas promo distribuidas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Registrar as cartas promo distribuídas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Registra le carte promo distribuite")
	return /** @type {LocalizedString} */ ("Record promo cards distributed")
});